import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { fileNameFromContentDisposition } from 'services/api/paymentGateway';
import { TDownloadedPartnerReportFile } from 'redux/reducers/referrals/types';
import { TReferralsApi } from './types';

export const referrals: TReferralsApi = {
	getReferralsPartners: payload =>
		http.post(endpoint.referrals.GET_REFERRALS_PARTNERS, payload).then(response => response.data),
	getPartners: payload =>
		http.post(endpoint.referrals.GET_PARTNERS, payload).then(response => response.data),
	createReferralPartners: payload =>
		http.post(endpoint.referrals.CREATE_REFERRAL_PARTNERS, payload),
	getAvailableEms: () =>
		http.get(endpoint.referrals.GET_AVAILABLE_EMS).then(response => response.data),
	createPartner: payload => http.post(endpoint.referrals.CREATE_PARTNER, payload),
	updatePartner: payload => http.put(endpoint.referrals.UPDATE_PARTNER, payload),
	getPartnerReports: payload =>
		http.post(endpoint.referrals.GET_PARTNER_REPORTS, payload).then(response => response.data),
	downloadPartnerReport: ({ id, fallbackFileName }) =>
		http
			.get<Blob>(endpoint.referrals.DOWNLOAD_PARTNER_REPORT(id), { responseType: 'blob' })
			.then(
				(response): TDownloadedPartnerReportFile => ({
					blob: response.data,
					fileName: fileNameFromContentDisposition(
						response.headers?.['content-disposition'] as string | undefined,
						fallbackFileName,
					),
				}),
			),
};
